
import React from 'react';
import BlogCard from './BlogCard';
import { cn } from '@/lib/utils';

interface BlogSectionProps {
  title?: string;
  description?: string;
  posts: any[];
  className?: string;
}

const BlogSection = ({ 
  title = "Latest Articles", 
  description = "Stay updated with our latest research and insights.",
  posts,
  className 
}: BlogSectionProps) => {
  if (!posts || posts.length === 0) {
    return null;
  }
  
  return (
    <section className={cn("py-8", className)}>
      {(title || description) && (
        <div className="text-center mb-8">
          {title && <h2 className="text-3xl font-bold mb-3">{title}</h2>}
          {description && (
            <p className="text-muted-foreground max-w-2xl mx-auto">
              {description}
            </p>
          )}
        </div>
      )}

      <div className="flex flex-col space-y-4">
        {posts.map((post) => (
          <BlogCard key={post.id} post={post} className="w-full" />
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
